import "../Tweets.css";

//react
import { useEffect, useState } from "react";

//components
import TweetGraph from "../../reusable/TweetGraph/TweetGraph";

//antd
import { Typography } from "antd";

//hooks
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

//utils
import { getCsvData } from "../../../utils/functions/getCsvData";

//assets
import TEXT from "../../../utils/text/prensa.json";


//functionss
import { formatTrimesterLabel } from "../../../utils/functions/formatTrimesterLabel";

const { Title } = Typography;

export default function Sentiment({
  selectedCountry,
  countryName,
  countries,
  countryOptions,
  setImg1,
  setImg2,
  setImg3,
  setImg4,
}) {
  //language
  const { language } = useCurrentLanguage();

  //useState - data sent
  const [dataSent, setDataSent] = useState([]);

  //useState - data body
  const [dataBody, setDataBody] = useState([]);

  //useState - img url 1
  // const [imgUrl1, setImgUrl1] = useState("");
  const [imgUrl2, setImgUrl2] = useState("");
  const [imgUrl3, setImgUrl3] = useState("");
  // const [imgUrl4, setImgUrl4] = useState("");

  const isLac = selectedCountry === "LAC";

  //useEffect
  useEffect(() => {
    processDataT2();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountry, countries]);

  //useEffect - imgs
  useEffect(() => {
    // setImg1(imgUrl1)
    setImg2(imgUrl2);
    setImg3(imgUrl3);
    // setImg4(imgUrl4)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imgUrl2, imgUrl3]);

  const processDataT2 = async () => {
    let df1 = await getCsvData(`/data/sentiment/sentiment_3m.csv`);

    //filter country
    if (selectedCountry !== "LAC") {
      df1 = df1.filter((row) => row.country === selectedCountry);
    } else {
      let tempDf1 = {};

      df1.forEach((e) => {
        let date = formatTrimesterLabel(e.date, language);

        if (!tempDf1[date]) {
          tempDf1[date] = {
            date: e.date,
            positive_sentiment: 0,
            negative_sentiment: 0,
            neutro_sentiment: 0,
            positive_body: 0,
            negative_body: 0,
            neutro_body: 0,
            count: 0,
          };
        }
        tempDf1[date].positive_sentiment +=
          parseFloat(e.positive_sentiment) || 0;
        tempDf1[date].negative_sentiment +=
          parseFloat(e.negative_sentiment) || 0;
        tempDf1[date].neutro_sentiment += parseFloat(e.neutro_sentiment) || 0;
        tempDf1[date].positive_body += parseFloat(e.positive_body) || 0;
        tempDf1[date].negative_body += parseFloat(e.negative_body) || 0;
        tempDf1[date].neutro_body += parseFloat(e.neutro_body) || 0;
        tempDf1[date].count++;
      });

      df1 = Object.values(tempDf1).map((entry) => ({
        date: entry.date,
        positive_sentiment: entry.positive_sentiment / entry.count,
        negative_sentiment: entry.negative_sentiment / entry.count,
        neutro_sentiment: entry.neutro_sentiment / entry.count,
        positive_body: entry.positive_body / entry.count,
        negative_body: entry.negative_body / entry.count,
        neutro_body: entry.neutro_body / entry.count,
      }));
    }

    let dates = [];
    let dates2 = [];
    let values = [];
    let values2 = [];
    let values3 = [];
    let values4 = [];
    let values5 = [];
    let values6 = [];

    df1.forEach((e) => {
      dates.push(formatTrimesterLabel(e.date, language));
      dates2.push(formatTrimesterLabel(e.date, language));
      values.push(parseFloat(e.negative_sentiment));
      values2.push(parseFloat(e.positive_sentiment));
      values3.push(parseFloat(e.neutro_sentiment));
      values4.push(parseFloat(e.negative_body));
      values5.push(parseFloat(e.positive_body));
      values6.push(parseFloat(e.neutro_body));
    });

    //delete last two element for all arrays: TEMPORAL

    const seriesName1 =
      language === "es"
        ? ["Sentimiento negativo", "Sentimiento positivo", "Sentimiento neutro"]
        : ["Negative sentiment", "Positive sentiment", "Neutral sentiment"];
    const seriesName2 =
      language === "es"
        ? ["Cuerpo negativo", "Cuerpo positivo", "Cuerpo neutro"]
        : ["Negative body", "Positive body", "Neutral body"];

    let combinedArray1 = [values, values2, values3];

    let combinedArray2 = [values4, values5, values6];

    let series1 = seriesName1.map((name, index) => {
      return {
        name: name,
        data: combinedArray1[index],
        type: "bar",
        stack: "a",
        itemStyle: {
          borderRadius: index === 2 ? [10, 10, 0, 0] : [0, 0, 0, 0],
        },
      };
    });

    let series2 = seriesName2.map((name, index) => {
      return {
        name: name,
        data: combinedArray2[index],
        type: "bar",
        stack: "a",
        itemStyle: {
          borderRadius: index === 2 ? [10, 10, 0, 0] : [0, 0, 0, 0],
        },
      };
    });

    let temp = [
      {
        id: "q1",
        data: series1,
        rotate: false,
        graphType: "s_v_bar",
        hasOptions: false,
        isPercentage: true,
        labels: dates,
        updateTotrimester: false,
        useColors: false,
        description: TEXT["indicadores"]["sentiment1"][language],
      },
    ];

    let temp2 = [
      {
        id: "q1",
        data: series2,
        rotate: false,
        graphType: "s_v_bar",
        hasOptions: false,
        isPercentage: true,
        labels: dates2,
        updateTotrimester: false,
        useColors: false,
        description: TEXT["indicadores"]["sentiment1"][language],
      },
    ];

    setDataSent(temp);
    setDataBody(temp2);
  };

  return (
    <div className="surveys-page-content prensa-small-section-container">
      <div className="surveys-page-graphs">
        <div className="survey-page-full-surveys">
          <div className="full-screen">
            <div className="prensa-chart-info-large-container">
              <div className="data-page-section-title text-left prensa-chart-title">
                {TEXT["sentiment"][language]}
              </div>
              {isLac && (
                <>
                  <Title
                    level={2}
                    style={{ color: "var(--blue-primary)", textAlign: "left" }}
                  >
                    {TEXT["sentiment"]["title"][language]}
                  </Title>
                  <div className="prensa-text-container">
                    <p>{TEXT["sentiment"]["description"][language]}</p>
                  </div>
                </>
              )}
            </div>
            <div>
              {dataSent.length > 0 && (
                <TweetGraph
                  data={dataSent}
                  title={
                    TEXT["sentiment"]["pos_neg"]["title"][language] +
                    " " +
                    countryName
                  }
                  setImgUrl={setImgUrl2}
                />
              )}              
              {dataBody.length > 0 && (
                <TweetGraph
                  data={dataBody}
                  title={
                    TEXT["sentiment"]["pos_neg_body"]["title"][language] +
                    " " +
                    countryName
                  }
                  setImgUrl={setImgUrl3}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
